const replaceIcons = (): void => {
  const replacePipedTextWithSpan = (): void => {
    // Define the regex to match text between pipe symbols
    const regex = /\|([^|]+)\|/g;

    // Function to replace the matched text with a span
    const replaceMatches = (text: string): string => {
      return text.replace(regex, (match, p1) => {
        const className = p1; // .trim().replace(/\s+/g, '-') // Replace spaces with dashes
        return `<i class="${className}"></i>`; // ${p1}
      });
    };

    // Function to traverse all text nodes and replace the matched text
    const traverseNodes = (node: any): void => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (regex.test(node.nodeValue)) {
          const newNode = document.createElement('span');
          newNode.innerHTML = replaceMatches(node.nodeValue);
          node.parentNode.replaceChild(newNode, node);
        }
      } else {
        for (const child of node.childNodes) {
          traverseNodes(child);
        }
      }
    };

    // Start traversing from the body element
    traverseNodes(document.body);
  };

  // Example usage: call the function to replace piped text with spans
  replacePipedTextWithSpan();
};

export default replaceIcons;
